import HTTP from "libs/http";

class Wechat extends HTTP {
  async getAccessToken(code: string) {
    const response = await this.get(
      `/chatbot-server/api/wechat/accessToken?code=${code}`
    );
    return response;
  }

  async checkAndRefreshAccessToken(openId: string) {
    const response = await this.post(
      "/chatbot-server/api/wechat/checkAndRefreshAccessToken",
      { openId }
    );
    return response;
  }

  async getUserInfo(openId: string) {
    const response = await this.get(
      `/chatbot-server/api/wechat/userInfo?openId=${openId}`
    );
    return response;
  }

  async getWXConfig(url = "") {
    return await this.post("/wechat/jsapi_signature", { url });
  }

  async mapUserToWXUser(code: string) {
    return await this.post("/wechat/code", { code });
  }

  async WXBusinessLogin({ crop_id, code }: { crop_id: string; code: string }) {
    return await this.post("/account/qywx/login", { crop_id, code });
  }

  async detectWXJump() {
    return await this.post("/wechat/sync_check");
  }

  async getWutianLoginConfig() {
    return await this.post("/account/wt_config");
  }

  async wutianLogin({ code }: { code: string }) {
    return await this.post("/account/wt_login", { code });
  }

  async teamsLogin({
    token,
    companyID,
  }: {
    token: string;
    companyID: string;
  }) {
    return await this.post("/account/teams_login", { token, companyID });
  }
}
export default new Wechat();
